import ProductBundle from '@common/components/ProductBundle';
import ProductDetailsWrapper from '@common/containers/Wrapper/ProductDetailPage';
import { RootState } from '@common/store';
import {
  addBundleProductToCartSuccess,
  addProductToCart,
  CartSliceType,
  subtractProductFromCart,
} from '@common/store/cart/slice';
import { CategoriesSliceType, fetchCategoriesRequest } from '@common/store/categories/slice';
import {
  fetchProductBundleRequest,
  fetchProductDetailsRequest,
  fetchProductReviewsRequest,
  ProductDetailsSliceType,
} from '@common/store/productDetails/slice';
import { fetchProductsRequest } from '@common/store/products/slice';
import { ProductsSliceType } from '@common/store/products/slice';
import { RecentlyViewedSliceType } from '@common/store/recentlyViewed/slice';
import { StoreInfoSliceType } from '@common/store/storeInfo/slice';
import { addToast, ToastWithKeyType } from '@common/store/toasts/slice';
import Event from '@components/Event';
import PageLayout from '@components/PageLayout';
import Product from '@components/Product';
import Rating from '@components/Rating';
import RecentlyViewed from '@components/RecentlyViewed';
import Share from '@components/Share';
import Link from '@lib/Link';
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';

interface MatchParams {
  productId: string;
  productSlug: string;
}

interface ProductDetailProps extends RouteComponentProps<MatchParams> {
  cart: CartSliceType;
  productDetails: ProductDetailsSliceType;
  products: Record<string, ProductsSliceType>;
  categories: CategoriesSliceType;
  recentlyViewed: RecentlyViewedSliceType;
  addToast: typeof addToast;
  toasts: ToastWithKeyType[];
  addProductToCart: typeof addProductToCart;
  subtractProductFromCart: typeof subtractProductFromCart;
  fetchProductsRequest: typeof fetchProductsRequest;
  fetchCategoriesRequest: typeof fetchCategoriesRequest;
  fetchProductDetailsRequest: typeof fetchProductDetailsRequest;
  fetchProductReviewsRequest: typeof fetchProductReviewsRequest;
  storeInfo: StoreInfoSliceType;
  addBundleProductToCartSuccess: typeof addBundleProductToCartSuccess;
  fetchProductBundleRequest: typeof fetchProductBundleRequest;
}

class ProductDetails extends React.Component<ProductDetailProps> {
  constructor(props) {
    super(props);
  }

  render() {
    const { productDetails, addToast, addProductToCart, cart, addBundleProductToCartSuccess } = this.props;

    const product = productDetails.productDetails;
    const cartProductQuantity = cart.quantityByProductId[product?.id] || 0;
    const features = this.props?.features?.features || {};

    return (
      <PageLayout>
        <ProductDetailsWrapper
          RecentlyViewed={RecentlyViewed}
          fetchCategoryReq={true}
          props={this.props}
          recentlyViewedClassnames={[
            'w-full md:bg-bgLight mt-50 md:mt-100',
            'container md:mx-auto py-30 md:py-88',
            'container mx-auto py-32 md:py-80 ',
          ]}
          showToast={false}
          mdpProductPage={true}
          mdpStorePage={true}
        >
          <>
            <div className="container mx-auto mt-50 mb-20 add-ellipsis-1 text-14">
              <Link
                to="/"
                className="text-theme underline font-medium cursor-pointer"
                color-customisation="page-body-text"
              >
                Home
              </Link>
              <span className="text-body inline-block mx-4 h-8 text-14"> / </span>
              <span className="text-body font-normal" color-customisation="page-body-text">
                {product?.title ?? ''}
              </span>
            </div>
            {!product?.isEvent ? (
              <Product
                reviewsCount={this.props.productDetails.reviewsCount}
                subtractProductFromCart={this.props.subtractProductFromCart}
                product={product}
                addProductToCart={addProductToCart}
                addToast={addToast}
                cartProductQuantity={cartProductQuantity}
                isZoomEnabled={true}
                storeType={this.props.storeInfo.storeInfo?.storeType}
                review={this.props.productDetails?.reviews?.length}
                wishListFeature={features?.wishList}
                productVideoFeature={features?.productVideo}
              />
            ) : (
              <Event
                subtractProductFromCart={this.props.subtractProductFromCart}
                product={product}
                addProductToCart={addProductToCart}
                addToast={addToast}
                cartProductQuantity={cartProductQuantity}
                storeType={this.props.storeInfo.storeInfo?.storeType}
                review={this.props.productDetails?.reviews?.length}
                wishListFeature={features?.wishList}
                productVideoFeature={features?.productVideo}
              />
            )}

            {productDetails?.bundle && (
              <div className="container mx-auto bg-productBundle-extraLightGray py-70 mt-60">
                <ProductBundle
                  productsBundle={productDetails.bundle}
                  productId={product?.id}
                  addToBundleProductInCart={addBundleProductToCartSuccess}
                  priceClassName={'text-pricing-current'}
                  className={'bg-theme text-white rounded-full font-bold uppercase'}
                />
              </div>
            )}
            <Share className="container md:hidden mx-auto py-32" product={product} />
            <Rating
              productSlug={product?.slug}
              id={'product-reviews'}
              className="container mx-auto py-32 md:py-80 bg-beige"
              isNextReviewsLoading={productDetails.isNextReviewsLoading}
              isNextReviewsLoadingFailed={productDetails.isNextReviewsLoadingFailed}
              reviewsCount={productDetails.reviewsCount}
              nextReviewsUrl={productDetails.nextReviewsUrl}
              reviews={productDetails.reviews}
              productId={product?.id}
            />
          </>
        </ProductDetailsWrapper>
      </PageLayout>
    );
  }
}

export default connect(
  ({ cart, productDetails, products, categories, recentlyViewed, storeInfo, toasts, features }: RootState) => ({
    storeInfo,
    cart,
    products,
    categories,
    productDetails,
    recentlyViewed,
    toasts,
    features,
  }),
  {
    fetchProductsRequest,
    fetchProductDetailsRequest,
    fetchCategoriesRequest,
    fetchProductReviewsRequest,
    addToast,
    addProductToCart,
    subtractProductFromCart,
    fetchProductBundleRequest,
    addBundleProductToCartSuccess,
  },
)(ProductDetails);
